import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import FirstTimeBuyerByCity from "@/pages/FirstTimeBuyerByCity";

export const Route = createFileRoute("/first-time-buyer/city/$city")({
  head: ({ params }) => seoHead(`/first-time-buyer/city/${params.city}`),
  component: FirstTimeBuyerByCity,
});
